import { handleApiError } from "../../../utils/errors";
import { getAuthHeader } from "../../../utils/superagent";
import request from "superagent";
import { NFCTagRequestResponse } from "../nfcTagRequest.types";
import { LocationApiData, StatusApiData } from "../nfcTagRequestModel";

export const getFacilityNFCTagsRequests = async (
  facilityId: string
): Promise<NFCTagRequestResponse> => {
  return await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .get(`${global.api}/facility/nfcTagRequests/${facilityId}`)
    .set(await getAuthHeader())
    .then(({ body }) => body)
    .catch((error) => {
      handleApiError(error);
      throw error;
    });
};

export const createNewNFCTagsRequest = async (
  facilityId: string,
  numberOfTagsRequested: number
): Promise<void> => {
  return await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .post(`${global.api}/facility/nfcTagRequests`)
    .set(await getAuthHeader())
    .send({ facilityId, numberOfTagsRequested })
    .then(({ body }) => body.body)
    .catch((error) => {
      handleApiError(error);
      throw error;
    });
};

export const addNFCTagRequests = async (
  facilityId: string,
  numberOfTagsRequested: number
): Promise<void> => {
  return await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .put(`${global.api}/facility/nfcTagRequests`)
    .set(await getAuthHeader())
    .send({ facilityId, numberOfTagsRequested })
    .then(({ body }) => body.body)
    .catch((error) => {
      handleApiError(error);
      throw error;
    });
};

export const updateNFCTagRequestStatus = async (
  updateData: StatusApiData
): Promise<NFCTagRequestResponse> => {
  return await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .put(`${global.api}/facility/nfcTagRequests/status`)
    .set(await getAuthHeader())
    .send(updateData)
    .then((body) => body.body)
    .catch((error) => {
      handleApiError(error);
      throw error;
    });
};

export const updateNFCTagRequestLocation = async (
  updateData: LocationApiData
): Promise<NFCTagRequestResponse> => {
  return await request
    // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
    .put(`${global.api}/facility/nfcTagRequests/location`)
    .set(await getAuthHeader())
    .send(updateData)
    .then((body) => body.body)
    .catch((error) => {
      handleApiError(error);
      throw error;
    });
};
